import { BaseGetRequest } from './core/baseGetRequest';
import { QuotesList, QuotesListDynamicType} from 'acscp/api/models/quotesList';
import { Authentication } from './core/baseRequest';

export class QuotesRequest extends BaseGetRequest<QuotesList> {
    constructor(public bookingId: string) {
        super(`bookings/${bookingId}/quotes`, {}, QuotesListDynamicType, Authentication.SharingToken);
    }
}
